/* start For Cart notification */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
/* end For Cart notification */



//
// // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
// try {
//   document.querySelector(":focus-visible");
// } catch(e) {
//   focusVisiblePolyfill();
// }
//
// function focusVisiblePolyfill() {
//   const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
//   let currentFocusedElement = null;
//   let mouseClick = null;
//
//   window.addEventListener('keydown', (event) => {
//     if(navKeys.includes(event.code.toUpperCase())) {
//       mouseClick = false;
//     }
//   });
//
//   window.addEventListener('mousedown', (event) => {
//     mouseClick = true;
//   });
//
//   window.addEventListener('focus', () => {
//     if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
//
//     if (mouseClick) return;
//
//     currentFocusedElement = document.activeElement;
//     currentFocusedElement.classList.add('focused');
//
//   }, true);
// }
//

// function debounce(fn, wait) {
//   let t;
//   return (...args) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, args), wait);
//   };
// }
//

// /*
//  * Shopify Common JS
//  *
//  */
// if ((typeof window.Shopify) == 'undefined') {
//   window.Shopify = {};
// }
//
// Shopify.bind = function(fn, scope) {
//   return function() {
//     return fn.apply(scope, arguments);
//   }
// };
//
// Shopify.setSelectorByValue = function(selector, value) {
//   for (var i = 0, count = selector.options.length; i < count; i++) {
//     var option = selector.options[i];
//     if (value == option.value || value == option.innerHTML) {
//       selector.selectedIndex = i;
//       return i;
//     }
//   }
// };
//
// Shopify.addListener = function(target, eventName, callback) {
//   target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
// };
//
// Shopify.postLink = function(path, options) {
//   options = options || {};
//   var method = options['method'] || 'post';
//   var params = options['parameters'] || {};
//
//   var form = document.createElement("form");
//   form.setAttribute("method", method);
//   form.setAttribute("action", path);
//
//   for(var key in params) {
//     var hiddenField = document.createElement("input");
//     hiddenField.setAttribute("type", "hidden");
//     hiddenField.setAttribute("name", key);
//     hiddenField.setAttribute("value", params[key]);
//     form.appendChild(hiddenField);
//   }
//   document.body.appendChild(form);
//   form.submit();
//   document.body.removeChild(form);
// };
//
// Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
//   this.countryEl         = document.getElementById(country_domid);
//   this.provinceEl        = document.getElementById(province_domid);
//   this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
//
//   Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
//
//   this.initCountry();
//   this.initProvince();
// };
//
// Shopify.CountryProvinceSelector.prototype = {
//   initCountry: function() {
//     var value = this.countryEl.getAttribute('data-default');
//     Shopify.setSelectorByValue(this.countryEl, value);
//     this.countryHandler();
//   },
//
//   initProvince: function() {
//     var value = this.provinceEl.getAttribute('data-default');
//     if (value && this.provinceEl.options.length > 0) {
//       Shopify.setSelectorByValue(this.provinceEl, value);
//     }
//   },
//
//   countryHandler: function(e) {
//     var opt       = this.countryEl.options[this.countryEl.selectedIndex];
//     var raw       = opt.getAttribute('data-provinces');
//     var provinces = JSON.parse(raw);
//
//     this.clearOptions(this.provinceEl);
//     if (provinces && provinces.length == 0) {
//       this.provinceContainer.style.display = 'none';
//     } else {
//       for (var i = 0; i < provinces.length; i++) {
//         var opt = document.createElement('option');
//         opt.value = provinces[i][0];
//         opt.innerHTML = provinces[i][1];
//         this.provinceEl.appendChild(opt);
//       }
//
//       this.provinceContainer.style.display = "";
//     }
//   },
//
//   clearOptions: function(selector) {
//     while (selector.firstChild) {
//       selector.removeChild(selector.firstChild);
//     }
//   },
//
//   setOptions: function(selector, values) {
//     for (var i = 0, count = values.length; i < values.length; i++) {
//       var opt = document.createElement('option');
//       opt.value = values[i];
//       opt.innerHTML = values[i];
//       selector.appendChild(opt);
//     }
//   }
// };
//
//
//
// class ModalOpener extends HTMLElement {
//   constructor() {
//     super();
//
//     const button = this.querySelector('button');
//
//     if (!button) return;
//     button.addEventListener('click', () => {
//       const modal = document.querySelector(this.getAttribute('data-modal'));
//       if (modal) modal.show(button);
//     });
//   }
// }
// customElements.define('modal-opener', ModalOpener);
//
// class DeferredMedia extends HTMLElement {
//   constructor() {
//     super();
//     const poster = this.querySelector('[id^="Deferred-Poster-"]');
//     if (!poster) return;
//     poster.addEventListener('click', this.loadContent.bind(this));
//   }
//
//   loadContent(focus = true) {
//     if (!this.getAttribute('loaded')) {
//       const content = document.createElement('div');
//       content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
//
//       this.setAttribute('loaded', true);
//       const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
//       if (focus) deferredElement.focus();
//     }
//   }
// }
//
// customElements.define('deferred-media', DeferredMedia);
//
// class SliderComponent extends HTMLElement {
//   constructor() {
//     super();
//     this.slider = this.querySelector('[id^="Slider-"]');
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.enableSliderLooping = false;
//     this.currentPageElement = this.querySelector('.slider-counter--current');
//     this.pageTotalElement = this.querySelector('.slider-counter--total');
//     this.prevButton = this.querySelector('button[name="previous"]');
//     this.nextButton = this.querySelector('button[name="next"]');
//
//     if (!this.slider || !this.nextButton) return;
//
//     this.initPages();
//     const resizeObserver = new ResizeObserver(entries => this.initPages());
//     resizeObserver.observe(this.slider);
//
//     this.slider.addEventListener('scroll', this.update.bind(this));
//     this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
//     this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
//     this.slider.addEventListener('scroll', () => {
//     });
//   }
//
//   initPages() {
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
//     if (this.sliderItemsToShow.length < 2) return;
//     this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
//     this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
//     this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
//     this.update();
//   }
//
//   resetPages() {
//     this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
//     this.initPages();
//   }
//
//   update() {
//     const previousPage = this.currentPage;
//     this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
//
//     if (this.currentPageElement && this.pageTotalElement) {
//       this.currentPageElement.textContent = this.currentPage;
//       this.pageTotalElement.textContent = this.totalPages;
//     }
//
//     if (this.currentPage != previousPage) {
//       this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
//           currentPage: this.currentPage,
//           currentElement: this.sliderItemsToShow[this.currentPage - 1]
//         }}));
//     }
//
//     if (this.enableSliderLooping) return;
//
//     if (this.isSlideVisible(this.sliderItemsToShow[0])) {
//       this.prevButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.prevButton.removeAttribute('disabled');
//     }
//
//     if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
//       this.nextButton.setAttribute('disabled', 'disabled');
//     } else {
//       this.nextButton.removeAttribute('disabled');
//     }
//   }
//
//   isSlideVisible(element, offset = 0) {
//     const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
//     return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
//   }
//
//   onButtonClick(event) {
//     event.preventDefault();
//     const step = event.currentTarget.dataset.step || 1;
//     this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
//     this.slider.scrollTo({
//       left: this.slideScrollPosition
//     });
//   }
// }
//
// customElements.define('slider-component', SliderComponent);
//
// class SlideshowComponent extends SliderComponent {
//   constructor() {
//     super();
//     this.sliderControlWrapper = this.querySelector('.slider-buttons');
//     this.enableSliderLooping = true;
//
//     if (!this.sliderControlWrapper) return;
//
//     this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
//
//     this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
//     if (this.sliderItemsToShow.length > 0) {
//       this.currentPage = 1;
//     }
//
//     this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
//     this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
//     this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
//     this.setSlideVisibility();
//   }
//
//   onButtonClick(event) {
//     super.onButtonClick(event);
//     const isFirstSlide = this.currentPage === 1;
//     const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
//
//     if (!isFirstSlide && !isLastSlide) return;
//
//     if (isFirstSlide && event.currentTarget.name === 'previous') {
//       this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
//     } else if (isLastSlide && event.currentTarget.name === 'next') {
//       this.slideScrollPosition = 0;
//     }
//     this.slider.scrollTo({
//       left: this.slideScrollPosition
//     });
//   }
//
//   update() {
//     super.update();
//     this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
//     this.prevButton.removeAttribute('disabled');
//
//     if (!this.sliderControlButtons.length) return;
//
//     this.sliderControlButtons.forEach(link => {
//       link.classList.remove('slider-counter__link--active');
//       link.removeAttribute('aria-current');
//     });
//     this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
//     this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
//   }
//
//
//   autoRotateSlides() {
//     const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
//     this.slider.scrollTo({
//       left: slideScrollPosition
//     });
//   }
//
//   setSlideVisibility() {
//     this.sliderItemsToShow.forEach((item, index) => {
//       const button = item.querySelector('a');
//       if (index === this.currentPage - 1) {
//         if (button) button.removeAttribute('tabindex');
//         item.setAttribute('aria-hidden', 'false');
//         item.removeAttribute('tabindex');
//       } else {
//         if (button) button.setAttribute('tabindex', '-1');
//         item.setAttribute('aria-hidden', 'true');
//         item.setAttribute('tabindex', '-1');
//       }
//     });
//   }
//
//   linkToSlide(event) {
//     event.preventDefault();
//     const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
//     this.slider.scrollTo({
//       left: slideScrollPosition
//     });
//   }
// }
//
// customElements.define('slideshow-component', SlideshowComponent);
//
// var activeElem = 0;
// function videoPlayMobile(event, elem) {
//   if(event == 'stop') {
//     elem.querySelector(".js-video-action").classList.replace("play", "stop")
//     elem.querySelector("video").pause()
//     elem.querySelector("video").muted = false
//   } else {
//     elem.querySelector(".js-video-action").classList.replace("stop", "play")
//     elem.querySelector("video").play()
//     elem.querySelector("video").muted = false
//   }
// }
//
//
// function setActiveElemProductMobileSlider() {
//   var timer = null;
//   document.querySelector(".slider-mobile-gutter .slider--everywhere").addEventListener('scroll', () => {
//     if(timer !== null) {
//       clearTimeout(timer);
//     }
//     timer = setTimeout(function() {
//       const elems = document.querySelectorAll(".product__media-list li");
//       let active;
//       elems.forEach((elem, key) => {
//         const clientRect = elem.getBoundingClientRect()
//         const x = clientRect.x
//
//         if(x >= 0 && x < 100) active = key
//       })
//       if(active != activeElem) {
//         document.querySelectorAll(".product__media-list li").forEach(elem => {
//           elem.classList.remove('active')
//           if(elem.querySelector('.js-video'))  videoPlayMobile('stop', elem)
//         })
//         elems[active].classList.add('active')
//         if(elems[active].querySelector('.js-video')) videoPlayMobile('play', elems[active])
//         activeElem = active
//       }
//     }, 150);
//   });
// }
//
// window.addEventListener('DOMContentLoaded', ()=>{
//   document.querySelectorAll(".product__media-list .product__media-item")[0].classList.add('active')
//   if(document.querySelector(".slider-mobile-gutter .product__media-item")) {
//     setActiveElemProductMobileSlider()
//   }
//   document.querySelectorAll('.deferred-media__poster-button.motion-reduce').forEach( video => video.click())
//   document.querySelectorAll('video[autoplay="autoplay"]').forEach( video => video.play())
// });
